module.exports = __webpack_public_path__ + "static/media/laptop.24b90f30.png";